<template>
  <div>
    <v-list-item
      v-for="item in links"
      :key="item.text"
      :href="item.href"
      target="_blank"
      :id="getItemId(item, 'li-anchor')"
    >
      <v-list-item-icon>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ item.text }}
      </v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import LINKS from '../../../resources/js/quick-links';

export default {
  name: 'AnchorSidebarQuickLinks',
  data: () => ({
    links: [
      {
        text: 'Anchor Wiki',
        icon: 'mdi-location-exit',
        href: LINKS.wiki,
      },
      {
        text: 'Open Support Ticket',
        icon: 'mdi-help-circle',
        href: LINKS.serviceDesk,
      },
    ],
  }),
  methods: {
    getItemId: (item, prefix) => `${prefix}-${item.text.toLowerCase().split(' ').join('-')}`,
  },
};
</script>
